<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>签到记录</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col :span="8">
            <Form-item label="签到时间" >
              <Date-picker  v-model="dateRange" format="yyyy-MM-dd HH:mm:ss" :clearable="false" type="daterange"
                            placement="bottom-start"  placeholder="选择日期" style="width: 100%"
                            @on-change="onDateChange"></Date-picker>
            </Form-item>
          </Col>
          <Col :span="8">
            <Form-item label="外教运营">
              <Select v-model.number="queryParam.studyAdviserId" placeholder="全部"
                      @on-change="search" clearable >
                <Option v-for="item in studyAdviserList"
                        :value="item.id" :key="item.id">{{ item.nickname }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="8">
            <Form-item label="老师ID">
              <Input name="tchId"
                     v-model="queryParam.tchId"></Input>
            </Form-item>
          </Col>
          <Col :span="8">
            <Form-item label="老师姓名">
              <Input placeholder="支持模糊搜索" name="tchName"
                     v-model="queryParam.tchName"></Input>
            </Form-item>
          </Col>
          <Col :span="2">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                    @click="search" >搜索</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/tchSignTime/list"
          :params="queryParam" :onLoading="onLoading" operator=""></List>
    <tch-info-modal :value="showTchInfoModal" @on-close="showTchInfoModal=false" :tchId="tchId" :successCallback="search"></tch-info-modal>
  </div>
</template>

<script>
    import dates from '../../tools/date/dates'
    import TchInfoModal from './modal/TchInfoModal.vue'
    import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
    export default {
      components: { TchInfoModal },
      data () {
        let $constant = this.$constant
        let $moment = this.$moment
        return {
          searchLoading: false,
          rankScoreSeq: 0,
          reload: 0,
          showTchInfoModal: false,
          tchId: null,
          dateRange: [],
          studyAdviserList: [],
          queryParam: {
            startTime: null,
            endTime: null,
            studyAdviserId: null,
            tchId: '',
            tchName: '',
          },
          title: [
            {
              title: '老师ID/姓名',
              // width: 150,
              width: 180,
              align: 'center',
              render: (h, params) => {
                let row = params.row
                return renderTchNameWithScore(h, {
                  text: row.tchId + '-' + row.firstName + row.lastName,
                  score: row.monthRankScore,
                  onClick: () => this.openTchInfoModal(row.tchId)
                })
              }
            },
            {
              title: '授课类型',
              // width: 110,
              align: 'center',
              render: (h, params) => {
                let tchType = params.row.tchType
                let typeEnum = $constant.getEnum($constant.tchType, tchType)
                return h('span', typeEnum && typeEnum.text)
              }
            },
            {
              title: '首课时间',
              align: 'center',
              // width: 170,
              render: (h, params) => {
                let firstLessonTime = params.row.firstLessonTime
                return h('span', firstLessonTime && $moment(firstLessonTime, 'X').format('HH:mm'))
              }
            },
            {
              title: '签到时间',
              align: 'center',
              // width: 170,
              render: (h, params) => {
                let signInTime = params.row.signInTime
                let lateSign = params.row.lateSign
                let style = lateSign === 1 || lateSign === 2 ? 'color: #ed4014' : ''
                return h('span', {style: style}, signInTime && $moment(signInTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
              }
            },
            {
              title: '外管',
              align: 'center',
              key: 'studyAdviser'
            },
            {
              title: '签到状态',
              align: 'center',
              render: (h, params) => {
                let lateSign = params.row.lateSign
                if (lateSign === 1) {
                  return h('span', {style: 'color: #ed4014'}, '晚签')
                } else if (lateSign === 2) {
                  return h('span', {style: 'color: #ed4014'}, '迟到')
                }
                return h('span', '正常')
              }
            }
          ]
        }
      },
      mounted: function () {
        let self = this
        let query = self.$route.query
        if (query) {
          if (query.startTime) {
            self.dateRange[0] = dates.format(query.startTime * 1000, 'YYYY-MM-DD HH:mm:ss') + ''
          }
          if (query.endTime) {
            self.dateRange[1] = dates.format(query.endTime * 1000, 'YYYY-MM-DD HH:mm:ss') + ''
          }
        }
        this.$http.post('/adminUser/listByCondition', {adminGroupId: 7}).then(function (res) {
          if (!res || !res.data) {
            return
          }
          self.studyAdviserList = res.data
        })
      },
      created: function () {
        this.initDateRange()
      },
      methods: {
        initDateRange () {
          // if (this.dateRange.length < 2) {
          let startTime = new Date(new Date().toLocaleDateString()).getTime()
          let startDate = dates.format(startTime, 'YYYY-MM-DD HH:mm:ss')
          let endTime = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
          let endDate = dates.format(endTime, 'YYYY-MM-DD HH:mm:ss')
          this.dateRange = [startDate, endDate]
          this.queryParam.startTime = parseInt(startTime / 1000)
          this.queryParam.endTime = parseInt(endTime / 1000)
          // }
        },
        openTchInfoModal (val) {
          this.tchId = val
          this.showTchInfoModal = true
        },
        search () {
          this.reload = new Date().getTime()
        },
        onLoading (loading) {
          this.searchLoading = loading
        if (!loading) {
          this.loadMonthRankScores()
        }
        },
        loadMonthRankScores () {
          const table = this.$refs.dataList && this.$refs.dataList.tableData
          if (!table || !table.length) {
            return
          }
          const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
          const seq = ++this.rankScoreSeq
          const self = this
          fetchTchScoreMap(this.$http, ids).then(function (map) {
            if (seq !== self.rankScoreSeq) {
              return
            }
            applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
          })
        },
        onDateChange (dateRange) {
          if (dateRange && dateRange.length === 2) {
            this.queryParam.startTime = parseInt(new Date(dateRange[0]).getTime() / 1000)
            this.queryParam.endTime = parseInt(new Date(dateRange[1]).getTime() / 1000)
          } else {
            this.queryParam.startTime = parseInt(new Date(this.dateRange[0]).getTime() / 1000)
            this.queryParam.endTime = parseInt(new Date(this.dateRange[1]).getTime() / 1000)
          }
          this.search()
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// TchSignTimeList.vue?6a49f0d5